// extracted by mini-css-extract-plugin
export default {"container":"inviteFriends_container__MUtI3","contentContainer":"inviteFriends_contentContainer__oTN1H","mainHead":"inviteFriends_mainHead__oervg","para":"inviteFriends_para__OlTBg"};